import apiClient from "./axios"

export const getAccountBankAccountList = async (params = {}) => {
  const { data } = await apiClient.get("/account-bank-accounts", { params })
  return data
}

export const getAccountBankAccountById = async id => {
  const { data } = await apiClient.get(`/account-bank-accounts/${id}`)
  return data
}

export const createAccountBankAccount = async payload => {
  const { data } = await apiClient.post("/account-bank-accounts", payload)
  return data
}

export const updateAccountBankAccount = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(
    `/account-bank-accounts/${id}`,
    payload
  )
  return data
}

export const deleteAccountBankAccount = async id => {
  const { data } = await apiClient.delete(`/account-bank-accounts/${id}`)
  return data
}
